var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-full mx-auto p-6 bg-white shadow rounded"
  }, [_c('label', {
    staticClass: "block font-semibold mb-1"
  }, [_vm._v("Title *")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.title,
      expression: "form.title"
    }],
    staticClass: "w-full border rounded px-3 py-2 mb-4 focus:ring focus:ring-blue-400 focus:border-blue-400",
    attrs: {
      "type": "text",
      "placeholder": "Enter Title"
    },
    domProps: {
      "value": _vm.form.title
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;

        _vm.$set(_vm.form, "title", $event.target.value);
      }
    }
  }), _c('label', {
    staticClass: "block font-semibold mb-1"
  }, [_vm._v("Short Description *")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.short_desc,
      expression: "form.short_desc"
    }],
    staticClass: "w-full border rounded px-3 py-2 mb-4 focus:ring focus:ring-blue-400 focus:border-blue-400",
    attrs: {
      "placeholder": "Enter short description"
    },
    domProps: {
      "value": _vm.form.short_desc
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;

        _vm.$set(_vm.form, "short_desc", $event.target.value);
      }
    }
  }), _c('div', {
    staticClass: "grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6"
  }, [_c('div', {
    staticClass: "lg:col-span-2"
  }, [_c('label', {
    staticClass: "block font-semibold mb-1"
  }, [_vm._v("Banner *")]), _c('div', {
    staticClass: "w-full border-2 border-dashed rounded relative mb-2 cursor-pointer hover:border-blue-400 transition h-[316px] overflow-hidden"
  }, [_c('input', {
    ref: "fileInput",
    staticClass: "hidden",
    attrs: {
      "type": "file",
      "accept": ".png, .jpeg, .jpg"
    },
    on: {
      "change": _vm.uploadBanner
    }
  }), _c('div', {
    staticClass: "w-full h-full",
    on: {
      "click": function ($event) {
        return _vm.$refs.fileInput.click();
      }
    }
  }, [!_vm.form.banner ? _c('div', {
    staticClass: "flex flex-col items-center justify-center h-full text-gray-500"
  }, [_c('span', {
    staticClass: "text-4xl block mb-2"
  }, [_vm._v("+")]), _vm._v(" Click to upload or drag and drop ")]) : _c('div', {
    staticClass: "relative w-full h-full"
  }, [_c('img', {
    staticClass: "w-full h-full object-cover object-top",
    attrs: {
      "src": _vm.form.banner,
      "alt": "Banner Preview"
    }
  }), _c('div', {
    staticClass: "absolute bottom-0 w-full bg-black bg-opacity-50 text-white text-xs py-2 text-center"
  }, [_vm._v(" Click to change banner ")])])])]), _c('div', {
    staticClass: "flex space-x-4 mb-4 items-center mt-4"
  }, [_c('div', [_c('label', {
    staticClass: "block font-semibold mb-1"
  }, [_vm._v("Status")]), _c('div', {
    staticClass: "flex space-x-2"
  }, [_c('span', {
    staticClass: "px-4 py-1 rounded-full text-sm cursor-pointer transition",
    class: _vm.form.status === 'Active' ? 'bg-green-500 text-white' : 'bg-gray-200 text-gray-700',
    on: {
      "click": function ($event) {
        _vm.form.status = 'Active';
      }
    }
  }, [_vm._v(" Active ")]), _c('span', {
    staticClass: "px-4 py-1 rounded-full text-sm cursor-pointer transition",
    class: _vm.form.status === 'Inactive' ? 'bg-red-500 text-white' : 'bg-gray-200 text-gray-700',
    on: {
      "click": function ($event) {
        _vm.form.status = 'Inactive';
      }
    }
  }, [_vm._v(" Inactive ")])])])])]), _c('div', {
    staticClass: "lg:col-span-1 space-y-4"
  }, [_c('div', [_c('label', {
    staticClass: "block font-semibold mb-1"
  }, [_vm._v("Meta Keyword *")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.meta_keyword,
      expression: "form.meta_keyword"
    }],
    staticClass: "w-full border rounded px-3 py-2",
    domProps: {
      "value": _vm.form.meta_keyword
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;

        _vm.$set(_vm.form, "meta_keyword", $event.target.value);
      }
    }
  })]), _c('div', [_c('label', {
    staticClass: "block font-semibold mb-1"
  }, [_vm._v("Meta Description *")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.meta_desc,
      expression: "form.meta_desc"
    }],
    staticClass: "w-full border rounded px-3 py-2",
    attrs: {
      "rows": "4"
    },
    domProps: {
      "value": _vm.form.meta_desc
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;

        _vm.$set(_vm.form, "meta_desc", $event.target.value);
      }
    }
  })]), _c('div', [_c('label', {
    staticClass: "block font-semibold mb-1"
  }, [_vm._v("Alt Text *")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.alt_text,
      expression: "form.alt_text"
    }],
    staticClass: "w-full border rounded px-3 py-2",
    domProps: {
      "value": _vm.form.alt_text
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;

        _vm.$set(_vm.form, "alt_text", $event.target.value);
      }
    }
  })])])]), _c('label', {
    staticClass: "block font-semibold mb-1 mt-6"
  }, [_vm._v("Content *")]), _c('div', {
    staticClass: "mb-6 border rounded"
  }, [_c('TextEditorComponents', {
    model: {
      value: _vm.form.content,
      callback: function ($$v) {
        _vm.$set(_vm.form, "content", $$v);
      },
      expression: "form.content"
    }
  })], 1), _c('button', {
    staticClass: "bg-primary-400 hover:bg-primary-500 text-white font-bold py-2 px-6 rounded transition duration-200",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" Update Article ")])]);

}
var staticRenderFns = []

export { render, staticRenderFns }